export default "ALTER TABLE `function` ADD `identifier` text;\nUPDATE `function` SET `identifier` = '';\n"